import { a } from './chunk-IMSWER4T.js';

var o=(e=>(e.SLASHBASE="SLASHBASE",e.BRACKETBASE="BRACKETBASE",e.CUSTOM="CUSTOM",e))(o||{});var r=class{_client=a.instance;URL="import-mappings";async get(t){return (await this._client.get(`/${this.URL}/${t}/setting`)).data}async put(t,i){return (await this._client.put(`/${this.URL}/${t}/setting`,i)).data}};

export { o as a, r as b };
//# sourceMappingURL=chunk-OAKSPRQU.js.map
//# sourceMappingURL=chunk-OAKSPRQU.js.map